import script from "./TagEditRow.vue?vue&type=script&lang=ts&setup=true"
export * from "./TagEditRow.vue?vue&type=script&lang=ts&setup=true"

import "./TagEditRow.vue?vue&type=style&index=0&id=dddaf81e&scoped=true&lang=scss"

import exportComponent from "/github/workspace/client/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-dddaf81e"]])

export default __exports__